package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets23 {
  internal val names_35_daniel_txt: AssetResource by lazy { init_names_35_daniel_txt() }

  internal val names_36_ezra_01_txt: AssetResource by lazy { init_names_36_ezra_01_txt() }

  internal val names_36_ezra_04_txt: AssetResource by lazy { init_names_36_ezra_04_txt() }

  internal val names_36_ezra_05_txt: AssetResource by lazy { init_names_36_ezra_05_txt() }

  internal val names_36_ezra_06_txt: AssetResource by lazy { init_names_36_ezra_06_txt() }

  internal val names_36_ezra_07_txt: AssetResource by lazy { init_names_36_ezra_07_txt() }

  internal val names_36_ezra_08_txt: AssetResource by lazy { init_names_36_ezra_08_txt() }

  internal val names_36_ezra_10_txt: AssetResource by lazy { init_names_36_ezra_10_txt() }

  internal val names_36_ezra_txt: AssetResource by lazy { init_names_36_ezra_txt() }

  internal val names_37_nechemia_01_txt: AssetResource by lazy { init_names_37_nechemia_01_txt() }

  internal val names_37_nechemia_02_txt: AssetResource by lazy { init_names_37_nechemia_02_txt() }

  internal val names_37_nechemia_03_txt: AssetResource by lazy { init_names_37_nechemia_03_txt() }

  internal val names_37_nechemia_06_txt: AssetResource by lazy { init_names_37_nechemia_06_txt() }

  internal val names_37_nechemia_07_txt: AssetResource by lazy { init_names_37_nechemia_07_txt() }

  internal val names_37_nechemia_08_txt: AssetResource by lazy { init_names_37_nechemia_08_txt() }

  internal val names_37_nechemia_10_txt: AssetResource by lazy { init_names_37_nechemia_10_txt() }

  internal val names_37_nechemia_12_txt: AssetResource by lazy { init_names_37_nechemia_12_txt() }

  internal val names_37_nechemia_13_txt: AssetResource by lazy { init_names_37_nechemia_13_txt() }

  internal val names_37_nechemia_txt: AssetResource by lazy { init_names_37_nechemia_txt() }

  internal val names_38_divrei_hayamim_a_04_txt: AssetResource by lazy {
      init_names_38_divrei_hayamim_a_04_txt() }

  internal val names_38_divrei_hayamim_a_10_txt: AssetResource by lazy {
      init_names_38_divrei_hayamim_a_10_txt() }

  internal val names_38_divrei_hayamim_a_11_txt: AssetResource by lazy {
      init_names_38_divrei_hayamim_a_11_txt() }

  internal val names_38_divrei_hayamim_a_12_txt: AssetResource by lazy {
      init_names_38_divrei_hayamim_a_12_txt() }

  internal val names_38_divrei_hayamim_a_13_txt: AssetResource by lazy {
      init_names_38_divrei_hayamim_a_13_txt() }

  internal val names_38_divrei_hayamim_a_14_txt: AssetResource by lazy {
      init_names_38_divrei_hayamim_a_14_txt() }

  internal val names_38_divrei_hayamim_a_15_txt: AssetResource by lazy {
      init_names_38_divrei_hayamim_a_15_txt() }

  internal val names_38_divrei_hayamim_a_17_txt: AssetResource by lazy {
      init_names_38_divrei_hayamim_a_17_txt() }

  internal val names_38_divrei_hayamim_a_18_txt: AssetResource by lazy {
      init_names_38_divrei_hayamim_a_18_txt() }

  internal val names_38_divrei_hayamim_a_19_txt: AssetResource by lazy {
      init_names_38_divrei_hayamim_a_19_txt() }

  internal val names_38_divrei_hayamim_a_20_txt: AssetResource by lazy {
      init_names_38_divrei_hayamim_a_20_txt() }

  internal val names_38_divrei_hayamim_a_21_txt: AssetResource by lazy {
      init_names_38_divrei_hayamim_a_21_txt() }

  internal val names_38_divrei_hayamim_a_txt: AssetResource by lazy {
      init_names_38_divrei_hayamim_a_txt() }

  internal val names_39_divrei_hayamim_b_09_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_09_txt() }

  internal val names_39_divrei_hayamim_b_10_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_10_txt() }

  internal val names_39_divrei_hayamim_b_11_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_11_txt() }

  internal val names_39_divrei_hayamim_b_12_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_12_txt() }

  internal val names_39_divrei_hayamim_b_14_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_14_txt() }

  internal val names_39_divrei_hayamim_b_15_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_15_txt() }

  internal val names_39_divrei_hayamim_b_16_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_16_txt() }

  internal val names_39_divrei_hayamim_b_18_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_18_txt() }

  internal val names_39_divrei_hayamim_b_19_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_19_txt() }

  internal val names_39_divrei_hayamim_b_20_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_20_txt() }

  internal val names_39_divrei_hayamim_b_21_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_21_txt() }

  internal val names_39_divrei_hayamim_b_22_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_22_txt() }

  internal val names_39_divrei_hayamim_b_23_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_23_txt() }

  internal val names_39_divrei_hayamim_b_24_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_24_txt() }

  internal val names_39_divrei_hayamim_b_25_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_25_txt() }

  internal val names_39_divrei_hayamim_b_26_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_26_txt() }

  internal val names_39_divrei_hayamim_b_27_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_27_txt() }

  internal val names_39_divrei_hayamim_b_28_txt: AssetResource by lazy {
      init_names_39_divrei_hayamim_b_28_txt() }

  internal fun values(): List<AssetResource> = listOf(names_35_daniel_txt, names_36_ezra_01_txt,
      names_36_ezra_04_txt, names_36_ezra_05_txt, names_36_ezra_06_txt, names_36_ezra_07_txt,
      names_36_ezra_08_txt, names_36_ezra_10_txt, names_36_ezra_txt, names_37_nechemia_01_txt,
      names_37_nechemia_02_txt, names_37_nechemia_03_txt, names_37_nechemia_06_txt,
      names_37_nechemia_07_txt, names_37_nechemia_08_txt, names_37_nechemia_10_txt,
      names_37_nechemia_12_txt, names_37_nechemia_13_txt, names_37_nechemia_txt,
      names_38_divrei_hayamim_a_04_txt, names_38_divrei_hayamim_a_10_txt,
      names_38_divrei_hayamim_a_11_txt, names_38_divrei_hayamim_a_12_txt,
      names_38_divrei_hayamim_a_13_txt, names_38_divrei_hayamim_a_14_txt,
      names_38_divrei_hayamim_a_15_txt, names_38_divrei_hayamim_a_17_txt,
      names_38_divrei_hayamim_a_18_txt, names_38_divrei_hayamim_a_19_txt,
      names_38_divrei_hayamim_a_20_txt, names_38_divrei_hayamim_a_21_txt,
      names_38_divrei_hayamim_a_txt, names_39_divrei_hayamim_b_09_txt,
      names_39_divrei_hayamim_b_10_txt, names_39_divrei_hayamim_b_11_txt,
      names_39_divrei_hayamim_b_12_txt, names_39_divrei_hayamim_b_14_txt,
      names_39_divrei_hayamim_b_15_txt, names_39_divrei_hayamim_b_16_txt,
      names_39_divrei_hayamim_b_18_txt, names_39_divrei_hayamim_b_19_txt,
      names_39_divrei_hayamim_b_20_txt, names_39_divrei_hayamim_b_21_txt,
      names_39_divrei_hayamim_b_22_txt, names_39_divrei_hayamim_b_23_txt,
      names_39_divrei_hayamim_b_24_txt, names_39_divrei_hayamim_b_25_txt,
      names_39_divrei_hayamim_b_26_txt, names_39_divrei_hayamim_b_27_txt,
      names_39_divrei_hayamim_b_28_txt)
}

private fun init_names_35_daniel_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_35_daniel.txt\")") as String, rawPath =
    "peopleNames/names_35_daniel.txt")

private fun init_names_36_ezra_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_36_ezra-01.txt\")") as String, rawPath =
    "peopleNames/names_36_ezra-01.txt")

private fun init_names_36_ezra_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_36_ezra-04.txt\")") as String, rawPath =
    "peopleNames/names_36_ezra-04.txt")

private fun init_names_36_ezra_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_36_ezra-05.txt\")") as String, rawPath =
    "peopleNames/names_36_ezra-05.txt")

private fun init_names_36_ezra_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_36_ezra-06.txt\")") as String, rawPath =
    "peopleNames/names_36_ezra-06.txt")

private fun init_names_36_ezra_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_36_ezra-07.txt\")") as String, rawPath =
    "peopleNames/names_36_ezra-07.txt")

private fun init_names_36_ezra_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_36_ezra-08.txt\")") as String, rawPath =
    "peopleNames/names_36_ezra-08.txt")

private fun init_names_36_ezra_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_36_ezra-10.txt\")") as String, rawPath =
    "peopleNames/names_36_ezra-10.txt")

private fun init_names_36_ezra_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_36_ezra.txt\")") as String, rawPath =
    "peopleNames/names_36_ezra.txt")

private fun init_names_37_nechemia_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_37_nechemia-01.txt\")") as String, rawPath =
    "peopleNames/names_37_nechemia-01.txt")

private fun init_names_37_nechemia_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_37_nechemia-02.txt\")") as String, rawPath =
    "peopleNames/names_37_nechemia-02.txt")

private fun init_names_37_nechemia_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_37_nechemia-03.txt\")") as String, rawPath =
    "peopleNames/names_37_nechemia-03.txt")

private fun init_names_37_nechemia_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_37_nechemia-06.txt\")") as String, rawPath =
    "peopleNames/names_37_nechemia-06.txt")

private fun init_names_37_nechemia_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_37_nechemia-07.txt\")") as String, rawPath =
    "peopleNames/names_37_nechemia-07.txt")

private fun init_names_37_nechemia_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_37_nechemia-08.txt\")") as String, rawPath =
    "peopleNames/names_37_nechemia-08.txt")

private fun init_names_37_nechemia_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_37_nechemia-10.txt\")") as String, rawPath =
    "peopleNames/names_37_nechemia-10.txt")

private fun init_names_37_nechemia_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_37_nechemia-12.txt\")") as String, rawPath =
    "peopleNames/names_37_nechemia-12.txt")

private fun init_names_37_nechemia_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_37_nechemia-13.txt\")") as String, rawPath =
    "peopleNames/names_37_nechemia-13.txt")

private fun init_names_37_nechemia_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_37_nechemia.txt\")") as String, rawPath =
    "peopleNames/names_37_nechemia.txt")

private fun init_names_38_divrei_hayamim_a_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_38_divrei_hayamim_a-04.txt\")") as String, rawPath =
    "peopleNames/names_38_divrei_hayamim_a-04.txt")

private fun init_names_38_divrei_hayamim_a_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_38_divrei_hayamim_a-10.txt\")") as String, rawPath =
    "peopleNames/names_38_divrei_hayamim_a-10.txt")

private fun init_names_38_divrei_hayamim_a_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_38_divrei_hayamim_a-11.txt\")") as String, rawPath =
    "peopleNames/names_38_divrei_hayamim_a-11.txt")

private fun init_names_38_divrei_hayamim_a_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_38_divrei_hayamim_a-12.txt\")") as String, rawPath =
    "peopleNames/names_38_divrei_hayamim_a-12.txt")

private fun init_names_38_divrei_hayamim_a_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_38_divrei_hayamim_a-13.txt\")") as String, rawPath =
    "peopleNames/names_38_divrei_hayamim_a-13.txt")

private fun init_names_38_divrei_hayamim_a_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_38_divrei_hayamim_a-14.txt\")") as String, rawPath =
    "peopleNames/names_38_divrei_hayamim_a-14.txt")

private fun init_names_38_divrei_hayamim_a_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_38_divrei_hayamim_a-15.txt\")") as String, rawPath =
    "peopleNames/names_38_divrei_hayamim_a-15.txt")

private fun init_names_38_divrei_hayamim_a_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_38_divrei_hayamim_a-17.txt\")") as String, rawPath =
    "peopleNames/names_38_divrei_hayamim_a-17.txt")

private fun init_names_38_divrei_hayamim_a_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_38_divrei_hayamim_a-18.txt\")") as String, rawPath =
    "peopleNames/names_38_divrei_hayamim_a-18.txt")

private fun init_names_38_divrei_hayamim_a_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_38_divrei_hayamim_a-19.txt\")") as String, rawPath =
    "peopleNames/names_38_divrei_hayamim_a-19.txt")

private fun init_names_38_divrei_hayamim_a_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_38_divrei_hayamim_a-20.txt\")") as String, rawPath =
    "peopleNames/names_38_divrei_hayamim_a-20.txt")

private fun init_names_38_divrei_hayamim_a_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_38_divrei_hayamim_a-21.txt\")") as String, rawPath =
    "peopleNames/names_38_divrei_hayamim_a-21.txt")

private fun init_names_38_divrei_hayamim_a_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_38_divrei_hayamim_a.txt\")") as String, rawPath =
    "peopleNames/names_38_divrei_hayamim_a.txt")

private fun init_names_39_divrei_hayamim_b_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-09.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-09.txt")

private fun init_names_39_divrei_hayamim_b_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-10.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-10.txt")

private fun init_names_39_divrei_hayamim_b_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-11.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-11.txt")

private fun init_names_39_divrei_hayamim_b_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-12.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-12.txt")

private fun init_names_39_divrei_hayamim_b_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-14.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-14.txt")

private fun init_names_39_divrei_hayamim_b_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-15.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-15.txt")

private fun init_names_39_divrei_hayamim_b_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-16.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-16.txt")

private fun init_names_39_divrei_hayamim_b_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-18.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-18.txt")

private fun init_names_39_divrei_hayamim_b_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-19.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-19.txt")

private fun init_names_39_divrei_hayamim_b_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-20.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-20.txt")

private fun init_names_39_divrei_hayamim_b_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-21.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-21.txt")

private fun init_names_39_divrei_hayamim_b_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-22.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-22.txt")

private fun init_names_39_divrei_hayamim_b_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-23.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-23.txt")

private fun init_names_39_divrei_hayamim_b_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-24.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-24.txt")

private fun init_names_39_divrei_hayamim_b_25_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-25.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-25.txt")

private fun init_names_39_divrei_hayamim_b_26_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-26.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-26.txt")

private fun init_names_39_divrei_hayamim_b_27_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-27.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-27.txt")

private fun init_names_39_divrei_hayamim_b_28_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_39_divrei_hayamim_b-28.txt\")") as String, rawPath =
    "peopleNames/names_39_divrei_hayamim_b-28.txt")

public actual val SharedRes.assets.peopleNames.names_35_daniel_txt: AssetResource
  get() = CommonMainAssets23.names_35_daniel_txt

public actual val SharedRes.assets.peopleNames.names_36_ezra_01_txt: AssetResource
  get() = CommonMainAssets23.names_36_ezra_01_txt

public actual val SharedRes.assets.peopleNames.names_36_ezra_04_txt: AssetResource
  get() = CommonMainAssets23.names_36_ezra_04_txt

public actual val SharedRes.assets.peopleNames.names_36_ezra_05_txt: AssetResource
  get() = CommonMainAssets23.names_36_ezra_05_txt

public actual val SharedRes.assets.peopleNames.names_36_ezra_06_txt: AssetResource
  get() = CommonMainAssets23.names_36_ezra_06_txt

public actual val SharedRes.assets.peopleNames.names_36_ezra_07_txt: AssetResource
  get() = CommonMainAssets23.names_36_ezra_07_txt

public actual val SharedRes.assets.peopleNames.names_36_ezra_08_txt: AssetResource
  get() = CommonMainAssets23.names_36_ezra_08_txt

public actual val SharedRes.assets.peopleNames.names_36_ezra_10_txt: AssetResource
  get() = CommonMainAssets23.names_36_ezra_10_txt

public actual val SharedRes.assets.peopleNames.names_36_ezra_txt: AssetResource
  get() = CommonMainAssets23.names_36_ezra_txt

public actual val SharedRes.assets.peopleNames.names_37_nechemia_01_txt: AssetResource
  get() = CommonMainAssets23.names_37_nechemia_01_txt

public actual val SharedRes.assets.peopleNames.names_37_nechemia_02_txt: AssetResource
  get() = CommonMainAssets23.names_37_nechemia_02_txt

public actual val SharedRes.assets.peopleNames.names_37_nechemia_03_txt: AssetResource
  get() = CommonMainAssets23.names_37_nechemia_03_txt

public actual val SharedRes.assets.peopleNames.names_37_nechemia_06_txt: AssetResource
  get() = CommonMainAssets23.names_37_nechemia_06_txt

public actual val SharedRes.assets.peopleNames.names_37_nechemia_07_txt: AssetResource
  get() = CommonMainAssets23.names_37_nechemia_07_txt

public actual val SharedRes.assets.peopleNames.names_37_nechemia_08_txt: AssetResource
  get() = CommonMainAssets23.names_37_nechemia_08_txt

public actual val SharedRes.assets.peopleNames.names_37_nechemia_10_txt: AssetResource
  get() = CommonMainAssets23.names_37_nechemia_10_txt

public actual val SharedRes.assets.peopleNames.names_37_nechemia_12_txt: AssetResource
  get() = CommonMainAssets23.names_37_nechemia_12_txt

public actual val SharedRes.assets.peopleNames.names_37_nechemia_13_txt: AssetResource
  get() = CommonMainAssets23.names_37_nechemia_13_txt

public actual val SharedRes.assets.peopleNames.names_37_nechemia_txt: AssetResource
  get() = CommonMainAssets23.names_37_nechemia_txt

public actual val SharedRes.assets.peopleNames.names_38_divrei_hayamim_a_04_txt: AssetResource
  get() = CommonMainAssets23.names_38_divrei_hayamim_a_04_txt

public actual val SharedRes.assets.peopleNames.names_38_divrei_hayamim_a_10_txt: AssetResource
  get() = CommonMainAssets23.names_38_divrei_hayamim_a_10_txt

public actual val SharedRes.assets.peopleNames.names_38_divrei_hayamim_a_11_txt: AssetResource
  get() = CommonMainAssets23.names_38_divrei_hayamim_a_11_txt

public actual val SharedRes.assets.peopleNames.names_38_divrei_hayamim_a_12_txt: AssetResource
  get() = CommonMainAssets23.names_38_divrei_hayamim_a_12_txt

public actual val SharedRes.assets.peopleNames.names_38_divrei_hayamim_a_13_txt: AssetResource
  get() = CommonMainAssets23.names_38_divrei_hayamim_a_13_txt

public actual val SharedRes.assets.peopleNames.names_38_divrei_hayamim_a_14_txt: AssetResource
  get() = CommonMainAssets23.names_38_divrei_hayamim_a_14_txt

public actual val SharedRes.assets.peopleNames.names_38_divrei_hayamim_a_15_txt: AssetResource
  get() = CommonMainAssets23.names_38_divrei_hayamim_a_15_txt

public actual val SharedRes.assets.peopleNames.names_38_divrei_hayamim_a_17_txt: AssetResource
  get() = CommonMainAssets23.names_38_divrei_hayamim_a_17_txt

public actual val SharedRes.assets.peopleNames.names_38_divrei_hayamim_a_18_txt: AssetResource
  get() = CommonMainAssets23.names_38_divrei_hayamim_a_18_txt

public actual val SharedRes.assets.peopleNames.names_38_divrei_hayamim_a_19_txt: AssetResource
  get() = CommonMainAssets23.names_38_divrei_hayamim_a_19_txt

public actual val SharedRes.assets.peopleNames.names_38_divrei_hayamim_a_20_txt: AssetResource
  get() = CommonMainAssets23.names_38_divrei_hayamim_a_20_txt

public actual val SharedRes.assets.peopleNames.names_38_divrei_hayamim_a_21_txt: AssetResource
  get() = CommonMainAssets23.names_38_divrei_hayamim_a_21_txt

public actual val SharedRes.assets.peopleNames.names_38_divrei_hayamim_a_txt: AssetResource
  get() = CommonMainAssets23.names_38_divrei_hayamim_a_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_09_txt: AssetResource
  get() = CommonMainAssets23.names_39_divrei_hayamim_b_09_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_10_txt: AssetResource
  get() = CommonMainAssets23.names_39_divrei_hayamim_b_10_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_11_txt: AssetResource
  get() = CommonMainAssets23.names_39_divrei_hayamim_b_11_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_12_txt: AssetResource
  get() = CommonMainAssets23.names_39_divrei_hayamim_b_12_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_14_txt: AssetResource
  get() = CommonMainAssets23.names_39_divrei_hayamim_b_14_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_15_txt: AssetResource
  get() = CommonMainAssets23.names_39_divrei_hayamim_b_15_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_16_txt: AssetResource
  get() = CommonMainAssets23.names_39_divrei_hayamim_b_16_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_18_txt: AssetResource
  get() = CommonMainAssets23.names_39_divrei_hayamim_b_18_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_19_txt: AssetResource
  get() = CommonMainAssets23.names_39_divrei_hayamim_b_19_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_20_txt: AssetResource
  get() = CommonMainAssets23.names_39_divrei_hayamim_b_20_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_21_txt: AssetResource
  get() = CommonMainAssets23.names_39_divrei_hayamim_b_21_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_22_txt: AssetResource
  get() = CommonMainAssets23.names_39_divrei_hayamim_b_22_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_23_txt: AssetResource
  get() = CommonMainAssets23.names_39_divrei_hayamim_b_23_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_24_txt: AssetResource
  get() = CommonMainAssets23.names_39_divrei_hayamim_b_24_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_25_txt: AssetResource
  get() = CommonMainAssets23.names_39_divrei_hayamim_b_25_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_26_txt: AssetResource
  get() = CommonMainAssets23.names_39_divrei_hayamim_b_26_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_27_txt: AssetResource
  get() = CommonMainAssets23.names_39_divrei_hayamim_b_27_txt

public actual val SharedRes.assets.peopleNames.names_39_divrei_hayamim_b_28_txt: AssetResource
  get() = CommonMainAssets23.names_39_divrei_hayamim_b_28_txt
